import { sleep } from "@/core/common/utils/GenericUtils";
import { PLOC } from "../../common/presentation/PLOC";
import { FactoryNavigationGateway } from "../domain/FactoryNavigationGateway";
import { CALENDAR_PAGE_ID, LOGIN_PAGE_ID, SPLASH_SCREEN_PAGE_ID } from "../domain/PagesConsts";
import getCurrentPageTitleUseCase from "../domain/usecases/GetCurrentPageTitleUseCase";
import { PageChangeUseCase } from "../domain/usecases/PageChangeUseCase";
import { RetrieveCurrentPageUseCase } from "../domain/usecases/RetrieveCurrentPageUseCase";
import { WebEnvGateway } from "../domain/WebEnvGateway";
import { AppState, appInitialState } from "./AppState";
export class AppPLOC extends PLOC<AppState> {
  private webEnvGW: WebEnvGateway;
  private factory: FactoryNavigationGateway;

  constructor(webEnvGW: WebEnvGateway, factory: FactoryNavigationGateway) {
    super(appInitialState);
    this.webEnvGW = webEnvGW;
    this.factory = factory;
  }

  public retrieveCurrentPage(): void {
    const lCurrentPage = RetrieveCurrentPageUseCase.retrieveCurrentPage(
      this.webEnvGW,
      this.factory,
      this.state.loggedIn
    );
    this.changeState({
      ...this.state,
      currentPage: lCurrentPage,
      isIconbarOpen: lCurrentPage === CALENDAR_PAGE_ID
    });
  }

  public onPageChange(newCurrentPageId: string) {
    const pageChangeResult = PageChangeUseCase.explicitPageChange(
      this.webEnvGW,
      this.factory,
      (<AppState>this.state).currentPage,
      newCurrentPageId,
      this.state.loggedIn
    );
    if (pageChangeResult.isPageChanged)
      this.changeState({
        ...this.state,
        currentPage: pageChangeResult.pageId,
        isIconbarOpen: pageChangeResult.pageId === CALENDAR_PAGE_ID
      });
  }

  public onHashChange() {
    const pageChangeResult = PageChangeUseCase.pageChangeByHash(
      this.webEnvGW,
      this.factory,
      (<AppState>this.state).currentPage,
      this.state.loggedIn
    );
    if (pageChangeResult.isPageChanged)
      this.changeState({
        ...this.state,
        currentPage: pageChangeResult.pageId,
        isIconbarOpen: pageChangeResult.pageId === CALENDAR_PAGE_ID
      });
  }

  public getCurrentPageTitle(currentPage: string): string {
    return getCurrentPageTitleUseCase.getCurrentPageTitle(currentPage);
  }

  public onSessionRestore(sessionOk: boolean) {
    this.changeState({ ...this.state, loggedIn: sessionOk });
    this.retrieveCurrentPage();
  }

  public async onLogin(loginOk: boolean) {
    this.changeState({ ...this.state, loggedIn: loginOk });

    if (loginOk) {
      this.onPageChange(SPLASH_SCREEN_PAGE_ID);
      await sleep(3000);
    }

    this.onPageChange(loginOk ? CALENDAR_PAGE_ID : LOGIN_PAGE_ID);
  }

  public onLogout(logoutOk: boolean) {
    if (logoutOk) {
      this.onPageChange(LOGIN_PAGE_ID);
      this.closeLoggedUserMenu();
      this.changeState({ ...this.state, loggedIn: false, sessionExpired: false });
    }
  }

  public toggleLoggedUserMenuActive() {
    this.changeState({
      ...this.state,
      loggedUserMenuActive: !this.state.loggedUserMenuActive
    });
  }

  public closeLoggedUserMenu() {
    this.changeState({
      ...this.state,
      loggedUserMenuActive: false
    });
  }
}
